import { Injectable } from '@angular/core';
import { EnvironmentParameters } from '../models/environment-parameters';
import { IEnvironment } from '../models/environment';
import { IEnvironmentConfiguration } from '../models/environment-configuration';
import { EnvironmentCustomService } from '../environment-custom/services/environment-custom.service';
import { EnvironmentDataService } from '../services/environment.data.service';
import { ConfigMock } from './config-mock';
import * as _ from 'lodash';
import { AppDataService } from 'app/app.data.service';
import { RestApi } from 'app/auth/rest.api';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class EnvironmentService {

  private currentEnvironmentIndex: number;
  private currentEnvironmentOrigin: IEnvironment = {} as IEnvironment;
  private customsArrayOrigin: ICustom[] = [];
  private customMetadataArrayOrigin: ICustomMetadata[] = [];
  private pendingChangesDialog = new Subject<void>();

  showPendingChangesDialog$ = this.pendingChangesDialog.asObservable();
  changeDialogResponse$ = new Subject<boolean>();
  saveAll$ = new Subject<boolean>();
  environmentConfiguration: IEnvironmentConfiguration = { environments: [] } as IEnvironmentConfiguration;
  currentEnvironment: IEnvironment = {} as IEnvironment;


  constructor(
    private _environmentDataService: EnvironmentDataService,
    private _environmentCustomService: EnvironmentCustomService,
    private _appDataService: AppDataService,
    private _restApi: RestApi
  ) {
    this.currentEnvironment.parameters = ({} as EnvironmentParameters);
    this.currentEnvironment.customs = ({} as ICustomMetadata);
  };

  showPendingChangesDialog() {
    this.pendingChangesDialog.next();
  }

  checkForPendingChanges(): Observable<void> {
    return new Observable<void>((observer) => {
      if (this.isThereAnyPendingChange()) {

        this.showPendingChangesDialog();
        this.changeDialogResponse$.subscribe((saveChanges: boolean) => {
          if (saveChanges) {
            this.saveAll$.next();
          }

          observer.next();
        });
      } else {
        observer.next();
      }

    });

  }
  isThereAnyPendingChange() {
    return !(_.isEqual(this.currentEnvironmentOrigin, this.currentEnvironment)
      && _.isEqual(this.customsArrayOrigin, this._environmentCustomService.customsArray)
      && _.isEqual(this.customMetadataArrayOrigin, this._environmentCustomService.customMetadataArray));
  }

  saveEnvironmentConfiguration(): Observable<void> {
    const self = this;
    return new Observable<void>(observer => {
      let environmentConfigurationCopy: IEnvironmentConfiguration;

      environmentConfigurationCopy = { ...this.environmentConfiguration };

      environmentConfigurationCopy.environments[this.currentEnvironmentIndex] = this.currentEnvironment;

      for (let index = 0; index < environmentConfigurationCopy.environments.length; index++) {
        environmentConfigurationCopy.environments[index].customs =
          this._environmentCustomService.customsArray[index];
        environmentConfigurationCopy.environments[
          index
        ].parameters.cryptographyKeyUrl = JSON.stringify(
          environmentConfigurationCopy.environments[index].parameters
            .cryptographyKeyUrlFormat
        );
      }

      environmentConfigurationCopy.content = {
        environments: JSON.stringify(environmentConfigurationCopy.environments),
        customMetadata: this._environmentCustomService.customMetadataArray
      };

      environmentConfigurationCopy.environments = [];

      this._environmentDataService.saveEnvironmentConfiguration([environmentConfigurationCopy])
        .subscribe(result => {
          this.setOriginData(self.currentEnvironment,
            self._environmentCustomService.customsArray,
            self._environmentCustomService.customMetadataArray);
          observer.next();
          observer.complete();
        });
    });

  };

  public getEnvironmentConfiguration(): Observable<IEnvironment> {

    const self = this;

    return new Observable<IEnvironment>(observer => {
      this._environmentDataService.getEnvironmentConfiguration()
        .subscribe(async data => {

          try {
            if (typeof (data.customMetadata) === 'string') {
              data.customMetadata = JSON.parse(data.customMetadata);
            }
            await this.setCurrentEnvironment();
            self.environmentConfiguration = data;
            self.environmentConfiguration.customMetadata = data.customMetadata
            self.currentEnvironmentIndex = self.environmentConfiguration.environments.findIndex(this.getCurrentEnvironmentIndex);

            self.currentEnvironment = self.environmentConfiguration.environments[this.currentEnvironmentIndex];
            observer.next(self.currentEnvironment);

            self._environmentCustomService.customsArray = this.getCustomsArray(self.environmentConfiguration.environments);
            self._environmentCustomService.customMetadataArray = self
              .environmentConfiguration.customMetadata
              ? self.environmentConfiguration.customMetadata
              : new Array<ICustomMetadata>();

            self.setOriginData(
              self.currentEnvironment,
              self._environmentCustomService.customsArray,
              self._environmentCustomService.customMetadataArray
            );
            self._environmentCustomService.currentCustomIndex = this.currentEnvironmentIndex;

            observer.complete();
          } catch (error) {
          }
        });
    });
  };

  private setOriginData(environment, customsArray, customMetadataArray) {

    this.currentEnvironmentOrigin = _.cloneDeep(environment);
    this.customsArrayOrigin = _.cloneDeep(customsArray);
    this.customMetadataArrayOrigin = _.cloneDeep(customMetadataArray);
  }

  private getCustomsArray(environments: Array<IEnvironment>): Array<ICustom> {
    const customsArray: Array<ICustom> = [];
    environments.forEach(environment => {
      customsArray.push(environment.customs);
    });
    return customsArray;
  }

  private getCurrentEnvironmentIndex(environments) {
    return environments.environment === sessionStorage.getItem('environmentType'); // TODO: Resolve environment type;
  }

  private async setCurrentEnvironment() {
    const environmentType = sessionStorage.getItem('environmentType');
    if (!environmentType) {
      const currentEnvironment: any = await this._appDataService.getCurrentEnvironment().toPromise();
      sessionStorage.setItem('environmentType', currentEnvironment.Current);
    }
  }

  saveEmailConfiguration(emailConfiguration: any): Observable<any> {
    return this._restApi.post(`api/Environment/UpdateEmailConfiguration`, emailConfiguration);
  }
}
